import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { injectHotkeyManagerService } from '@libs/shared/hotkey/hotkey-manager.service';
import { allAllowInElements } from '@libs/shared/utils/const/shortcut';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-lock-extension-dialog',
  template: `
    <ng-container *ngLet="data | async as seconds">
      <div mat-dialog-content>
        @if (seconds) {
          <div class="w-100 flex flex-col items-center">
            <div class="w-30 h-30">
              <img src="assets/images/logo/logo.svg" alt="logo" />
            </div>
            <div class="text-lg font-bold">
              {{ seconds | secondsToMinutes }} 남았습니다.
            </div>
            <div class="text-lg font-bold">15분 더 연장하시겠습니까?</div>
            @if (seconds >= 300) {
              <div class="text-secondary text-base">
                (만료 5분 전에 연장 가능)
              </div>
            }
          </div>
        }
        @if (!seconds) {
          <app-loading-spinner />
        }
      </div>
      <div mat-dialog-actions class="flex flex-row justify-end">
        <button mat-stroked-button (click)="onClose()">닫기</button>
        <button
          mat-flat-button
          color="primary"
          [disabled]="seconds >= 300"
          (click)="onSubmit()">
          연장하기
        </button>
      </div>
    </ng-container>
  `,
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LockExtensionDialogComponent implements AfterViewInit, OnDestroy {
  readonly hotkeyManager = injectHotkeyManagerService();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: Observable<number>,
    public matDialogRef: MatDialogRef<LockExtensionDialogComponent, string>
  ) {}

  ngAfterViewInit(): void {
    this.hotkeyManager.activateHotkeysForComponent(this.constructor.name, [
      {
        keys: 'meta.enter',
        description: '저장하기',
        allowIn: allAllowInElements,
        action: () => {
          this.onSubmit();
        },
      },
      {
        keys: 'escape',
        description: '닫기',
        allowIn: allAllowInElements,
        action: () => {
          this.onClose();
        },
      },
    ]);
  }

  ngOnDestroy(): void {
    this.hotkeyManager.deactivateHotkeys(this.constructor.name);
  }

  onSubmit() {
    this.matDialogRef.close('extend');
  }

  onClose() {
    this.matDialogRef.close('close');
  }
}
